import React from 'react';
import { Award, Globe, Headphones, Settings } from 'lucide-react';

const benefits = [
  {
    title: 'Certified Infor WMS Expertise',
    description: 'Certified specialists across WMS, Infor OS, warehouse automation, and labor management.',
    backgroundColor: '#FFF1EE',
    borderColor: '#FFD7D0',
    iconBackground: '#FFE1DB',
    accentColor: '#D81820',
    icon: Award,
  },
  {
    title: 'Proven WMS Implementation Methodology',
    description: 'Agile process mapping, configuration, validation, and testing reduce operational risk.',
    backgroundColor: '#EEF6FF',
    borderColor: '#CFE3FF',
    iconBackground: '#DCEBFF',
    accentColor: '#2563EB',
    icon: Settings,
  },
  {
    title: 'End-to-End WMS Lifecycle Support',
    description: '24/7 support, monitoring, health checks, optimization, and continuous improvement.',
    backgroundColor: '#EFFBF3',
    borderColor: '#CDEED8',
    iconBackground: '#DDF5E5',
    accentColor: '#16803C',
    icon: Headphones,
  },
  {
    title: 'Global Implementation & Scalability',
    description: 'Scale from one warehouse to multi-site, multi-country operations with confidence.',
    backgroundColor: '#FFF8E8',
    borderColor: '#F7E3B2',
    iconBackground: '#FFEDC4',
    accentColor: '#B7791F',
    icon: Globe,
  },
];

const WhyChooseCard = ({
  icon: Icon,
  title,
  description,
  backgroundColor,
  borderColor,
  iconBackground,
  accentColor,
}) => (
  <article
    className="group flex h-full min-w-0 flex-col rounded-2xl border p-6 transition duration-300 hover:-translate-y-1 hover:shadow-lg"
    style={{
      backgroundColor,
      borderColor,
      boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)',
    }}
  >
    <div
      className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl transition duration-300 group-hover:scale-105"
      style={{ backgroundColor: iconBackground, color: accentColor }}
    >
      <Icon aria-hidden="true" className="h-5 w-5" strokeWidth={1.9} />
    </div>

    <h3 className="mb-3 text-lg font-bold leading-snug" style={{ color: '#1A2634' }}>
      {title}
    </h3>

    <p className="mt-auto text-sm font-medium leading-6" style={{ color: '#334155', textAlign: 'left' }}>
      {description}
    </p>
  </article>
);

const WhyChoose = () => {
  return (
    <section
      aria-labelledby="wms-why-choose-title"
      className="px-4 py-14 sm:px-6 lg:px-8 lg:py-20"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      <div className="mx-auto w-full max-w-7xl">
        <h2
          id="wms-why-choose-title"
          className="mb-10 text-2xl font-bold tracking-tight sm:text-3xl md:text-4xl"
          style={{ color: '#1A2634' }}
        >
          Why Choose PT KCS for Infor WMS?
        </h2>

        <div className="grid gap-5 sm:grid-cols-2">
          {benefits.map((benefit) => (
            <WhyChooseCard key={benefit.title} {...benefit} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
